
(function ($) {
    $(document).ready(function () {
        $('.ua-ie body .blog-detail').addClass("cl-ie");

        $('.blog-detail .intro-with-card .card-wrapper p').text(function () {
            if ($(this).text().length > 130) {
                var  currentText=$(this).text();
                var subText= currentText.substr(0, 130) + '...';
                return subText;
            }
        });

        $('.blog-detail .intro-with-card .card-wrapper ul a').text(function () {
            if ($(this).text().length > 33) {
                var  currentText=$(this).text();
                var subText= currentText.substr(0, 33) + '...';
                return subText;
            }
        });

        var topicLength= $('.blog-detail .card-wrapper ul li').length;
        if(topicLength>3){
            $('.blog-detail .card-wrapper ul li').each(function () {
                if($(this).index()+1<=3) {
                    $(this).fadeIn();
                }
            });
            $('.blog-detail .card-wrapper  ul').append('<li style="display: list-item;"><a href="#" class="more-btn">View More +</a></li>');
        }else {
            $('.blog-detail .card-wrapper ul li').fadeIn();
        }

        var clickCount=0;
        $('.blog-detail .card-wrapper ul .more-btn').click(function (e) {
            e.preventDefault();
            clickCount++;
            $('.blog-detail .card-wrapper ul li').each(function () {
                if($(this).index()+1>3) {
                    $(this).fadeIn();
                }
            });
            if(clickCount>=0) {
                $('.blog-detail .card-wrapper ul .more-btn').css('display','none');
            }
        });

    });

    $(window).on('load resize orientationChange',function () {

        var winWidth=$(window).width();
        if($('.blog-detail .col-wrapper h3').is(':first-child')){
            $('.blog-detail .card-wrapper').addClass('margin-large');
        }else {
            $('.blog-detail .col-wrapper p:first-child').addClass('margin-large');
        }

        var cardLength=$(' .blog-detail .card-wrap').length;
        if(winWidth>767) {
            if(cardLength>3) {
                $('.blog-detail .card-wrap').each(function () {
                    if($(this).index()<=3) {
                        $(this).css('display','inline-block');
                    }
                });
                $('.ua-mobile:not(.ua-mobile-ipad) body .blog-detail .card-wrap').css('display','none');
            }else {
                $('.blog-detail .card-wrap').css('display','inline-block');
                $('.ua-mobile:not(.ua-mobile-ipad) body .blog-detail .card-wrap').css('display','none');
            }
        }else {
            $('.blog-detail .card-wrap').css('display','none');
        }
    });
})(jQuery);
